import styled from 'styled-components/native';
import { TextInput } from '../TextInput';
import { StyledTextAreaProps } from './types';

export const TextArea = styled(TextInput)<StyledTextAreaProps>`
    height: ${({ numberOfLines }) => `${numberOfLines * 36}px`};
    min-height: 55px;
`;
